import React from 'react'

function GoogleLogIn() {
  return (
    <a
      href="https://google.com"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white text-red-600 border-2 border-red-600 hover:bg-red-600 
      hover:text-white font-normal text-center px-4 py-2 md:px-6 md:py-2 
      rounded-full transition-colors duration-300 text-sm md:text-base"
    >
      Google
    </a>
  )
}

export default GoogleLogIn